// extracted by mini-css-extract-plugin
module.exports = {"Footer":"index-module--Footer--3cXKE","Footer__wrapper":"index-module--Footer__wrapper--1Iz5w","Footer__social":"index-module--Footer__social--1Iko3"};